document.addEventListener('DOMContentLoaded', function () {
  if (window.premierDeliveryPassSubscribeStateInitialized) return;
  window.premierDeliveryPassSubscribeStateInitialized = true;

  function isInCart(cart, productId, sellingPlanId) {
    return cart.items.some(function (item) {
      return (
        String(item.product_id) === productId &&
        item.selling_plan_allocation &&
        String(item.selling_plan_allocation.selling_plan.id) === sellingPlanId
      );
    });
  }

  function setButtonState(button, inCart) {
    if (inCart) {
      button.textContent = button.getAttribute('data-already-in-cart-text');
      button.setAttribute('disabled', 'disabled');
      button.classList.remove('button--primary');
      button.classList.add('button--ternary');
    } else {
      button.textContent = button.getAttribute('data-subscribe-text');
      button.removeAttribute('disabled');
      button.classList.remove('button--ternary');
      button.classList.add('button--primary');
    }
  }

  function updateButtons(cart) {
    document.querySelectorAll('[data-premier-delivery-pass-subscribe]').forEach(function (button) {
      const productId = button.getAttribute('data-product-id');
      const sellingPlanId = button.getAttribute('data-selling-plan-id');

      setButtonState(button, isInCart(cart, productId, sellingPlanId));
    });
  }

  document.documentElement.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.cart) {
      updateButtons(event.detail.cart);
    }
  });
});
